import { render, staticRenderFns } from "./goodsListPopup.vue?vue&type=template&id=5cc36363&scoped=true"
import script from "./goodsListPopup.vue?vue&type=script&lang=ts"
export * from "./goodsListPopup.vue?vue&type=script&lang=ts"
import style0 from "./goodsListPopup.vue?vue&type=style&index=0&id=5cc36363&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc36363",
  null
  
)

export default component.exports